module.exports = __webpack_public_path__ + "static/media/fawuzhuanyuan1.940c0a81.png";